export default [
    {
    path: '/customer_case',
    name: 'customer_case',
    component: () => import('@/pages/customer_case/index.vue')
    },
    {
      path: '/customer_case/big_data_sys',
      name: 'big_data_sys',
      component: () => import('@/pages/customer_case/big_data_sys.vue')
    },
    {
      path: '/customer_case/MPA',
      name: 'MPA',
      component: () => import('@/pages/customer_case/MPA.vue')
    },
    {
      path: '/customer_case/management_cockpit',
      name: 'management_cockpit',
      component: () => import('@/pages/customer_case/management_cockpit.vue')
    },
    {
      path: '/customer_case/anti_money_laundering',
      name: 'anti_money_laundering',
      component: () => import('@/pages/customer_case/anti_money_laundering.vue')
    },
    {
      path: '/customer_case/business_account',
      name: 'business_account',
      component: () => import('@/pages/customer_case/business_account.vue')
    },
    {
      path: '/customer_case/pad_market',
      name: 'pad_market',
      component: () => import('@/pages/customer_case/pad_market.vue')
    },
]



// WEBPACK FOOTER //
// ./src/router/customer_case.js